export default __webpack_public_path__ + "static/lab_staff_upgrade-05de100d61465142bf3e8dc4eb8996cc.png";